<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-lg-9">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard">
                  <div class="row">
                    <div class="col-sm-12">
                     <h4 class="reference">Refrigeration Checklist</h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                  <form @submit.prevent="updateOrder">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="itemsGroup">
                          
                          
                          <div class="itemsList">
                            <dt class="item">Site Address</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.site_address_id">
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.site_address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Asset</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.asset_id">
                                  <option v-for="asset in assets" :key="asset.id" :value="asset.id" :selected="asset.id === order.asset_id">({{ asset.serial }}) {{ asset.name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Engineer</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.engineer">
                                  <option value="Will Rae">Will Rae</option>
                                  <option value="Ben White">Ben White</option>
                                  
                                </select>
                              </div>
                            </dd>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-6">
        
                          <div class="itemsGroup">
                            <div class="itemsList">
                            <dt class="item">Contact</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="contact in contacts" :key="contact.id" :value="contact.id" :selected="contact.id === order.contact_id">{{ contact.first_name }} {{ contact.last_name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                            <div class="itemsList">
                              <dt class="item">Reference</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_reference" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Customer PO</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_po" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Xero Invoice Number</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.xero_invoice_number" /></dd>
                            </div>
                            
                          </div>
                        </div>
                      <div class="col-sm-4">
                        
                      </div>
                    </div>
                    




                    <div class="row">
                      <div class="col-sm-2">
                        <label style="text-align:left;">Job Description</label>
                      </div>
                      <div class="col-sm-10">
                        <textarea v-model="order.job_description" rows="5" placeholder="Job Description"></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>


                    
                    <div class="row">
                      <div class="col-sm-12">
                        <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="60%">Checklist</td>
                <td width="20%">Inspection Ok</td>
                <td width="20%">Comments</td>
            </tr>

            <tr>
                <td>Check the evaporator coils and drain lines for ice build up and blockages respectively</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_1_comments" /></td>
            </tr>

            <tr>
                <td>Look for signs of corrosion on various parts of the units</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_2_comments" /></td>
            </tr>

            <tr>
                <td>Check for excessive vibrations or noise during operation, as well as oil stains on some components</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_3_comments" /></td>
            </tr>

            <tr>
                <td>Inspect the doors for torn gaskets</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_4_comments" /></td>
            </tr>

            <tr>
                <td>Clean the condenser coil, and flush until no residue left</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_5_comments" /></td>
            </tr>

            <tr>
                <td>Check drain pan and drain line for blockages</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_6_comments" /></td>
            </tr>

            <tr>
                <td>Check the wiring for any signs of wear or damage, make sure all connections are secure</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_7_comments" /></td>
            </tr>

            <tr>
                <td>Check compressor is pumping correctly</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_8" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_8_comments" /></td>
            </tr>

            <tr>
                <td>Test the operation/calibration of the fan cycle and defrost controls, and adjust if needed</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_9" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_9_comments" /></td>
            </tr>

            <tr>
                <td>Inspect the heaters to ensure they make even surface contact with the coil, and check drain line heater tape</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_10" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_10_comments" /></td>
            </tr>

            <tr>
                <td>Measure the unit cooler and superheat, and ensure it matches the specific application</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_11" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_11_comments" /></td>
            </tr>

            <tr>
                <td>Check the coils for even distribution</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_12" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_12_comments" /></td>
            </tr>

            <tr>
                <td>Check the refrigerant levels</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.point_13" value="Pass"><span class="checkmark"></span></label></td>
                <td><input type="text" class="text" v-model="refridgeration.point_13_comments" /></td>
            </tr>

            <tr>
                <td>&nbsp;</td>
                <td>Refrigerant Type</td>
                <td><input type="text" class="text" v-model="refridgeration.point_14_comments" /></td>
            </tr>

            <tr>
                <td>&nbsp;</td>
                <td>Refrigerant Charge</td>
                <td><input type="text" class="text" v-model="refridgeration.point_15_comments" /></td>
            </tr>
            
       </table>

       

       
       <table width="100%" border="1" cellpadding="0" cellspacing="0" style="margin-top: 30px;">
            <tr>
                <td class="" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>
                        
                      </div>
                      
                      
                    </div>
                    <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  
                  <!--
                  <div class="row">
                    
                    <div class="col-lg-6">
                      <div class="row" v-if="order.signature_image">
                        <div class="col-sm-2">Name</div>
                        <div class="col-sm-4">
                          {{ order.engineer }}
                        </div>
                        <div class="col-sm-2">Signture</div>
                        <div class="col-sm-4">
                          <img :src="order.signature_image" width="100%" />
                        </div>

                      </div>
                      <div class="row" v-else>
                        <div class="col-sm-2">Name</div>
                        <div class="col-sm-4">
                          {{ order.engineer }}
                        </div>
                        <div class="col-sm-2">Signture</div>
                        <div class="col-sm-4">
                          <VueSignaturePad width="100%" height="100px" ref="signaturePadEngineer" style="border: 1px solid #c6c6c6;" />
                        </div>

              
                      </div>
                    </div>
                  </div>
                    -->
                  

                    <div class="row">
                      <div class="col-sm-1">
                        
                      </div>
                      <div class="col-sm-3">
                        
                      </div>
                      <div class="col-sm-8">
                        <div align="right">
                          <input type="submit" value="Save Job">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                         <a @click.prevent="deleteJob()" class="btnRedText">Delete Job</a>
                      </div>
                      
                      <div class="col-sm-8">
                        
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Reports</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <!--<a class="btnOrderAction" @click.prevent="finaliseOrder()">Finalise <font-awesome-icon icon="angle-double-right" /></a>-->
                      <a href="#" @click.prevent="$openPdf('refridgeration-checklist', order.id)" class="btnOrderAction">Small Maintenance Checklist <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  
                </div>
                
                <div v-if="order.asset_id">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>F-Gas Leak Check</h6>
                    </div>
                  </div>
                  <div v-if="leak_check_view">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Test Result</dt>
                              <dd class="item"><input type="text" class="text" v-model="leakcheck.result" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Further Actions</dt>
                              <dd class="item"><input type="text" class="text" v-model="leakcheck.further" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <a @click.prevent="leakTest()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="col-sm-12">
                        <p>I have performed an F-Gas Leak Check in accordance of EU 517/2014.</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <a @click.prevent="goLeakTest()" class="btnGreenLine" >Create Leak Check <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>F-Gas Movements</h6>
                    </div>
                  </div>
                  <div v-if="addgas">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Amount added (Kg)</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasadd.amount_gas" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Reason for</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasadd.reason" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 15px;">
                      <div class="col-sm-12">
                        <a @click.prevent="addGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div v-if="removegas">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Amount removed (Kg)</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasremove.amount_gas" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Reason for</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasremove.reason" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 15px;">
                      <div class="col-sm-12">
                        <a @click.prevent="removeGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <a class="btnGreenLine" @click.prevent="goAddGas()" >Add Gas <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                    <div class="col-sm-6">
                      <a class="btnGreenLine" @click.prevent="goRemoveGas()" >Remove Gas <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>
                </div>

                <div class="pageCard greenTop" v-if="order.status==='processing'">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Complete Job</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="completeOrder()" class="btnOrderAction" target="_blank" >Complete Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>

                <div class="pageCard greenTop" v-if="!order.invoice_status">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Invoice Job</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="invoiceOrder()" class="btnOrderAction" target="_blank" >Invoice Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import axios from 'axios'

export default {
  components: { /*DatePicker*/ },
  data () {
    return {
      order: [],
      contacts: [],
      addresses: [],
      refridgeration: [],
      assets: [],
      leak_check_view: false,
      leakcheck: {},
      addgas: false,
      removegas: false,
      fgasadd: {},
      fgasremove: {},
    }
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  created () {
    axios
      .get(`/api/orders/${this.$route.params.id}`)
      .then((res) => {
        this.order = res.data.order
        axios
          .get(`/api/companies/${this.order.company_id}/contacts`)
          .then(response => {
            this.contacts = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })
        axios
          .get(`/api/orders/${this.order.id}/refrdigeration`)
          .then(response => {
            this.refridgeration = response.data[0]
          })
        axios
          .get(`/api/companies/${this.order.company_id}/assets`)
          .then(response => {
            this.assets = response.data
          })
      })
    
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
      this.searchProduct()
    },
    onBlur: function () {
      // this.isVisible = false
    },
    goLeakTest () {
      this.leak_check_view = true
    },
    leakTest () {

      this.leakcheck.asset_id = this.order.asset_id
      this.leakcheck.engineer = this.order.engineer
      this.leakcheck.type = 'Leak Check'

      axios
        .post('/api/fgas', this.leakcheck)
        .then(response => {
          this.$toast.success("Leak Check completed", {})
          this.leak_check_view = false
        })

    },
    goAddGas () {
      this.removegas = false
      this.addgas = true
    },
    goRemoveGas () {
      this.addgas = false
      this.removegas = true
    },
    addGas () {

      this.fgasadd.asset_id = this.order.asset_id
      this.fgasadd.engineer = this.order.engineer
      this.fgasadd.type = 'Addition'

      axios
        .post('/api/fgas', this.fgasadd)
        .then(response => {
          this.$toast.success("F-Gas Addition completed", {})
          this.addgas = false
        })

    },
    removeGas () {

      this.fgasremove.asset_id = this.order.asset_id
      this.fgasremove.engineer = this.order.engineer
      this.fgasremove.type = 'Removal'

      axios
        .post('/api/fgas', this.fgasremove)
        .then(response => {
          this.$toast.success("F-Gas Removal completed", {})
          this.removegas = false
        })

    },
    deleteJob () {
      if(confirm("Do you really want to delete this job?")){
      axios
        .delete(`/api/orders/${this.$route.params.id}`)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job deleted", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
    },
    updateOrder () {

      let dates= new Date()
          let month = dates.getUTCMonth() + 1
          let day = dates.getUTCDate()
          let year = dates.getUTCFullYear()
          let currentDate = year + "-" + month + "-" + day
      /*
      if (!this.order.signature_image) {
        const { isEmptyEngineer, dataEngineer } = this.$refs.signaturePad.saveSignature();

        if (!isEmptyEngineer) {
          this.order.date_signed = currentDate;
          this.order.currentDate = dataEngineer;
        }

      }
      */

      axios
        .put(`/api/orders/${this.$route.params.id}`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          axios
            .put(`/api/refridgeration/${this.$route.params.id}`, this.refridgeration)
            .then(response => (
              this.$toast.success("Job saved", {}),
              this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
            ))
            .catch(err => console.log(err))
            // .finally(() => this.loading = false)
         
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    completeOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/complete`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job completed", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    invoiceOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/invoice`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job invoiced", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
  }
}
</script>
